<video controls><source src="{{{o.url}}}" type="video/mp4"></video>
<a target="_blank" rel="noopener" href="{{{o.url}}}">{{{o.label_download}}}</a>
